
const SingleFAQArea = ({text , ID ,content}) => {

  return (
  	<>
	    <dt className="wave" data-toggle="collapse" data-target={`#${ID}`}>{text}</dt>
	    <dd data-aos="fade-up" id={ID} className="collapse">
		<p>{content}</p>
	    </dd>

  	</>
  );
}

export default SingleFAQArea;